import { RESPONSE_TYPES } from '../constants/http-response.constants';
import {
  APISetup,
  NetworkResponse,
  RequestSettings,
} from '../types/services/request.types';
import RequestService from './request.service';

export class RequestHandler {
  protected api: APISetup = null;

  get<T>(url: string, settings?: Partial<Pick<RequestSettings, 'responseType' | 'standardSettings'>>): NetworkResponse<T> {
    return RequestService.get<T>(
      url,
      {
        responseType: RESPONSE_TYPES.JSON,
        ...(settings || {}),
        api: this.api,
      },
    );
  }

  post<T>(url: string, settings?: Partial<Pick<RequestSettings, 'responseType' | 'standardSettings'>>): NetworkResponse<T> {
    return RequestService.post<T>(
      url,
      {
        responseType: RESPONSE_TYPES.JSON,
        ...(settings || {}),
        api: this.api,
      },
    );
  }

  patch<T>(url: string, settings?: Partial<Pick<RequestSettings, 'responseType' | 'standardSettings'>>): NetworkResponse<T> {
    return RequestService.patch<T>(
      url,
      {
        responseType: RESPONSE_TYPES.JSON,
        ...(settings || {}),
        api: this.api,
      },
    );
  }

  put<T>(url: string, settings?: Partial<Pick<RequestSettings, 'responseType' | 'standardSettings'>>): NetworkResponse<T> {
    return RequestService.put<T>(
      url,
      {
        responseType: RESPONSE_TYPES.JSON,
        ...(settings || {}),
        api: this.api,
      },
    );
  }

  delete<T>(url: string, settings?: Partial<Pick<RequestSettings, 'responseType' | 'standardSettings'>>): NetworkResponse<T> {
    return RequestService.delete<T>(
      url,
      {
        responseType: RESPONSE_TYPES.JSON,
        ...(settings || {}),
        api: this.api,
      },
    );
  }
}
